<template class="fixed-header">
  <v-data-table
    :headers="headers"
    :items="history"
    :class="{ 'layout-fixed': $vuetify.breakpoint.lgAndUp }"
    fixed-header
    :sort-by="dateOfVisit"
    :items-per-page="itemsPerPage"
    :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
    @update:items-per-page="saveItemsPerPage"
    :sort-desc="true"
    :no-data-text="resx.messages.noVisitsAvailable"
    :no-results-text="resx.messages.noVisitsFound"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td>
          <v-icon color="success" v-if="item.hasRequestAccess == null"
            >check_circle</v-icon
          >
          <span class="not-suitable-text" v-if="item.hasRequestAccess != null">
            {{ resx.labels.notSuitableAcronim }}</span
          >
        </td>
        <td>{{ item.dateOfVisit | date("short") }}</td>
        <td class="hidden-xs-only">
          {{ item.endOfVisit | date("short") }}
        </td>
        <td class="hidden-xs-only">{{ formatDuration(item) }}</td>
        <td>
          <div v-if="item.closedAt">
            <star-rating
              :read-only="true"
              :star-size="20"
              :rating="item.rate"
              :padding="8"
              :show-rating="false"
              :rounded-corners="true"
              active-color="#4caf50"
            >
            </star-rating>
          </div>
          <span class="error--text" v-else>{{
            resx.labels.pendingScoreVisit
          }}</span>
        </td>
        <td class="hidden-sm-and-down">
          <comments
            :readonly="true"
            :mode="'link'"
            :value="item.comment"
          ></comments>
        </td>
        <td class="hidden-sm-and-down">{{ item.motive }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
"use strict";

import moment from "moment";

import comments from "@/components/common/comments.vue";
import StarRating from "vue-star-rating";

export default {
  name: "contractorHistoryDetails",
  components: {
    StarRating,
    comments
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      headers: [
        {
          text: "",
          width: 160
        },
        {
          text: resx.labels.dateStart,
          value: "dateOfVisit",
          width: 160
        },
        {
          text: resx.labels.dateEnd,
          value: "endOfVisit",
          width: 160,
          class: "hidden-xs-only"
        },
        {
          text: resx.labels.visitDuration,
          value: "duration",
          class: "hidden-xs-only"
        },
        {
          text: resx.labels.qualification,
          value: "rate",
          width: 180
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.comments,
          value: "comment"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.motive,
          value: "motive"
        }
      ]
    };
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    formatDuration(visit) {
      if (visit.dateOfVisit && visit.endOfVisit) {
        return moment
          .utc(
            moment
              .duration(
                moment.duration(
                  moment(visit.endOfVisit)
                    .add(1, "minute")
                    .diff(visit.dateOfVisit)
                ),
                "minutes"
              )
              .asMilliseconds()
          )
          .format("HH:mm");
      } else {
        return "";
      }
    }
  },
  props: {
    history: { type: Array }
  }
};
</script>

<style lang="scss">
.not-suitable-text {
  color: red;
  font-weight: bold;
}
</style>
